<template>
        <div>
            <h3 v-if="!this.isAddEquipmentMode" class="editor-header px-2">
                {{ $t('boom_barrier_bollard.editor_title')  }}
            </h3>
            <location-deviation v-if="this.isAddEquipmentMode" :location-deviation="item.location_deviation"/>
            <div class="px-2">
                <div class="row" v-if="!this.isAddEquipmentMode">
                    <div class="col-sm-6">
                        <span class="span-title">{{ $t('common.id') }}</span>
                        <span class="item-detail-text">{{ item.external_system_id }}</span>
                    </div>
                    <div class="col-sm-6">
                        <road-addess-view :road-number="item.road_num" :section-number="item.road_sec" :distance="item.distance" :show-street-name="false"/>
                    </div>
                </div>
               <div class="row">
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('boom_barrier_bollard.type') }}</span>
                        <select
                            v-model="item.type"
                            class="form-control form-control-sm"
                            :class="{ 'is-invalid': !validateIsNumber(item.type) }"
                        >
                            <option :value="null">
                                {{ $t('boom_barrier_bollard.select_type') }}
                            </option>
                            <option
                                v-for="option in getBoomBarrierBollardTypes()"
                                :key="option.value"
                                :value="option.value"
                            >
                                {{ option.name }}
                            </option>
                        </select>
                    </div>
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('boom_barrier_bollard.material') }}</span>
                        <select
                            v-model="item.material"
                            class="form-control form-control-sm"
                        >
                            <option :value="null">
                                {{ $t('materials.select_material') }}
                            </option>
                            <option
                                v-for="option in getMaterials()"
                                :key="option.value"
                                :value="option.value"
                            >
                                {{ option.name }}
                            </option>
                        </select>
                    </div>
                    <div class="col-sm-4">
                        <condition-selector v-model="item.condition" :required="true"/>
                    </div>
                </div>
                <location-details
                    v-if="!this.isAddEquipmentMode"
                    :lane-data="item.location_specification.lane"
                    :side-data="item.location_specification.side"
                    :track-data="item.location_specification.tracks"
                />
               <div class="row">
                   <div class="col-sm-4">
                       <span class="span-title">{{ $t('boom_barrier_bollard.redefined_type.title') }}</span>
                       <select
                           v-model="item.refined_type"
                           class="form-control form-control-sm"
                       >
                           <option :value="null">
                               {{ $t('boom_barrier_bollard.redefined_type.select_type') }}
                           </option>
                           <option
                               v-for="option in getBoomBarrierBollardRedefinedTypes()"
                               :key="option.value"
                               :value="option.value"
                           >
                               {{ option.name }}
                           </option>
                       </select>
                   </div>

                   <div class="col-sm-4">
                       <span class="span-title">{{ $t('boom_barrier_bollard.technique.title') }}</span>
                       <select
                           v-model="item.technique"
                           class="form-control form-control-sm"
                       >
                           <option :value="null">
                               {{ $t('boom_barrier_bollard.select_technique') }}
                           </option>
                           <option
                               v-for="option in getBoomBarrierBollardTechniques()"
                               :key="option.value"
                               :value="option.value"
                           >
                               {{ option.name }}
                           </option>
                       </select>
                   </div>

                   <div class="col-sm-4">
                       <span class="span-title">{{ $t('boom_barrier_bollard.control_type.title') }}</span>
                       <select
                           v-model="item.control_type"
                           class="form-control form-control-sm"
                       >
                           <option :value="null">
                               {{ $t('boom_barrier_bollard.select_control_type') }}
                           </option>
                           <option
                               v-for="option in getBoomBarrierBollardControlTypes()"
                               :key="option.value"
                               :value="option.value"
                           >
                               {{ option.name }}
                           </option>
                       </select>
                   </div>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('boom_barrier_bollard.length') }}</span>
                        <input
                            id="length"
                            v-model="item.length"
                            type="number"
                            class="form-control form-control-sm"
                        />
                    </div>
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('boom_barrier_bollard.railway_level_crossing_boom_additional_type.title') }}</span>
                        <select
                            v-model="item.railway_level_crossing_boom_additional_type"
                            class="form-control form-control-sm"
                        >
                            <option :value="null">
                                {{ $t('boom_barrier_bollard.select_railway_level_crossing_boom_additional_type') }}
                            </option>
                            <option
                                v-for="option in getRailwayLevelCrossingBoomAdditionalTypes()"
                                :key="option.value"
                                :value="option.value"
                            >
                                {{ option.name }}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('portal.code') }}</span>
                        <input
                            id="code"
                            v-model="item.code"
                            type="text"
                            class="form-control form-control-sm"
                            min="1"
                        />
                    </div>
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('drain.product_name') }}</span>
                        <input
                            id="product_name"
                            v-model="item.product_name"
                            type="text"
                            class="form-control form-control-sm"
                            min="1"
                        />
                    </div>
                </div>
                <div class="row" v-if="this.isAddEquipmentMode">
                    <div class="col-sm-4">
                        <location-deviation :editMode="true" :location-deviation="item.location_deviation" @updateLocationDeviation="updateLocationDeviation"/>
                    </div>
                </div>
                <div class="row" v-if="this.isAddEquipmentMode">
                    <div class="col-sm-12 nopads mt-2">
                        <h4 class="form-header nopads mt-0">{{ $t('velho_equipment.location_spesifications') }}</h4>
                        <velho-equipment-location-details-editor
                        :hideRampSelector="true"
                        :hideShoulderSelector="true"
                        :hidePlatformSelector="true"
                        :hideEdgeAreaSelector="true"
                        :hideDitchBottomSelector="true"
                        :hideDividerSelector="true"
                        :hideCenterAreaSelector="true"
                        :roadInfo="item"
                        :locationSpecification="item.location_specification"
                        />
                    </div>
               </div>
                <hr class="mb-0">
                <div class="row" v-if="this.isAddEquipmentMode">
                    <div class="col-sm-6 nopads mt-2">
                        <equipment-date
                            :text="$t('velho_equipment.start_date')"
                            v-model="item.created_at"
                        />
                    </div>
                </div>
               <div class="row">
                    <div class="col-sm-12 nopads mt-2">
                        <velho-equipment-damages :items="item.equipment_damages"/>
                    </div>
               </div>
                <div class="row">
                    <equipment-actions v-if="!this.isAddEquipmentMode" ref="actions" v-model="item.actions" />
                </div>
                <div class="row">
                    <linked-equipment
                        v-if="item.linked_equipment && item.linked_equipment.length > 0"
                        :linked-equipments="item.linked_equipment"
                    />
                </div>
            </div>

            <velho-editor-buttons
                v-if="!this.isAddEquipmentMode"
                :url="extBoomsBarriersBollardsUrl"
                :selected-contract="selectedContract"
                :item="item"
                :disabled="loading"
                @close="close"
                @submit="handleSubmit"
                @removalConfirmed="removalConfirmed"
            />

        <div
            v-if="loading > 0"
            id="loader"
            class="spinner"
        />
    </div>
</template>

<script>
import {mapHelper} from "@/components/mixins/MapMixin";
import {conversionModelHelper, equipmentActions} from "@/components/mixins/ConversionMixin";
import {restApi} from "@/components/mixins/RestApiMixin";
import ConditionSelector from "@/components/velho/ConditionSelector";
import {velhoHelper} from "@/components/mixins/VelhoMixin";
import EquipmentActions from "@/components/velho/EquipmentActions";
import LinkedEquipment from "@/components/velho/LinkedEquipment";
import {boomBarrierBollardHelper} from "@/components/mixins/BoomBarrierBollardMixin";
import LocationDetails from "@/components/velho/LocationDetails.vue";
import LocationDeviation from "@/components/velho/LocationDeviation";
import VelhoEquipmentLocationDetailsEditor from "@/components/velho/VelhoEquipmentLocationDetailsEditor";
import VelhoEquipmentDamages from "@/components/velho/VelhoEquipmentDamages";
import RoadAddessView from "@/components/velho/RoadAddressView";
import {velhoValidationMixin} from "@/components/mixins/VelhoValidationMixin";
import BaseModal from "@/components/BaseModal";
import EquipmentDate from "@/components/velho/EquipmentDate.vue";
import VelhoEditorButtons from "@/components/velho/VelhoEditorButtons.vue";

export default {
    name: 'BoomsBarriersBollardsEditor',
    components: {
        VelhoEditorButtons,
        EquipmentDate,
        BaseModal,
        RoadAddessView,
        LocationDeviation,
        LocationDetails,
        EquipmentActions,
        ConditionSelector,
        LinkedEquipment,
        VelhoEquipmentLocationDetailsEditor,
        VelhoEquipmentDamages
    },
    mixins: [mapHelper, conversionModelHelper, restApi, velhoHelper, boomBarrierBollardHelper, velhoValidationMixin],
    props: {
        item: {
            type: Object,
            default: null
        },
        selectedContract: {
            type: Object,
            default: null
        },
        addEquipmentEditor: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isAddEquipmentMode() {
            return this.addEquipmentMode
        }
    },
    data() {
        return {
            addEquipmentMode: this.addEquipmentEditor,
            map: null,
            loading: false,
        }
    },
    methods: {
        handleSave: function(extBoomsBarriersBollardsUrl, item, selectedContract) {
            if(item.actions.includes(equipmentActions.REPLACE) || item.linked_equipment.some(x => x.hasOwnProperty("actions") && !!x.actions.find(y => y.value === equipmentActions.REPLACE))) {
                this.$refs.replaceModal.show()
            } else {
                this.handleSubmit(extBoomsBarriersBollardsUrl, item, selectedContract)
            }
        },
        handleSubmit: function(extBoomsBarriersBollardsUrl, item, selectedContract) {
            if(item.actions.includes(equipmentActions.REPLACE) || item.linked_equipment.some(x => x.hasOwnProperty("actions") && !!x.actions.find(y => y.value === equipmentActions.REPLACE))) {
                this.submitEquipmentsreplace(this.extEquipmentsReplaceUrl, [item], selectedContract)
            } else {
                this.submitEquipment(extBoomsBarriersBollardsUrl, item, selectedContract)
            }
        },
        close: function () {
            this.$emit('close')
        },
        updateLocationDeviation(value) {
            this.item.location_deviation = value
        },
        isValidForm: function() {
            if(!this.item) { return false }
            if(!this.validateRoadNumber(this.item.road_num)) { return false }
            if(!this.validateRoadSection(this.item.road_sec)) { return false }
            if(!this.validateRoadDistance(this.item.distance)) { return false }
            if(!this.validateRoadSide(this.item.location_specification.side)) { return false }
            if(!this.validateRoadTracks(this.item.location_specification.tracks)) { return false }
            if(!this.validateIsNumber(this.item.type)) { return false }
            if(!this.validateIsNumber(this.item.condition)) { return false }

            return true
        }
    }
}
</script>

<style scoped>
</style>

